import React, { useEffect } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/clients.png';
import { Wrapper } from './Landing';
import Quote from '../components/Quote';

const Clients = () => {
  useEffect(() => {
    document.title = 'Emprouen Advisors: Clients';
  }, []);

  return (
    <Wrapper>
      <PageGraphic src={imgGrpahic} />

      <div>
        <h2>Clients</h2>

        <Quote>
          Leveraging our vast experience and network in select industries such
          as consumer packaged goods, protein, agriculture, building materials,
          health and wellness, energy sector. We look at best practices for
          sustainability. management.
        </Quote>

        <p>
          We are retained by boards (publicly traded, private, or professionally
          managed), private equity and investment banking firms, special purpose
          acquisition companies (SPACs), owners, and trustees. Building on
          experience across the food service, consumer goods, building,
          industrial and energy sectors including manufacturing, distribution
          and retail verticals. Beyond the opportunity for growth here, we see a
          widespread need for sound, evidence-based management. Grounded by our
          recent successes, we are committed to shaping this emerging ecosystem
          into a mature, successful industry.
        </p>
      </div>
    </Wrapper>
  );
};

export default Clients;
